import React from 'react';
import { Box } from '@material-ui/core';
import { Typography } from '@orijinworks/frontend-commons';

const ExportSuccessMessage = () => (
    <Box>
        <Typography variant="body1">
            Please watch for an email from Orijin with a download link.{' '}
            <b>The link in the email will expire within 24 hours</b>. Depending on the size of the
            data the export could take up to a few hours.
        </Typography>
        <br />
        <Typography variant="body1">
            Remember to check your spam folder. If you don&apos;t see the file within 24 hours
            please reach out to Orijin support or try the export again.
        </Typography>
    </Box>
);

export default ExportSuccessMessage;
